import React from 'react'

const ButtonLike = ({outlineColor, className, style, onClick, active, thin, transparent, disabled}) => {
  return (
    <button
      className={`${transparent ? '' : 'bg-white'} border uppercase font-accent rounded text-center ${thin ? 'p-2' : 'p-4'} w-full text-sm ${disabled ? 'text-gray-999' : ''} ${className}`}
      style={{
        borderColor: outlineColor === 'primary' ? '#ddd' : '#ddd',
        ...style
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {
        active ? (
          <div className="w-full flex items-center justify-center">
            <div><img className="mr-2" src="/images/icons/khub_heart_active.svg" alt="bookmark"/></div>
            <div>Liked</div>
          </div>
        ) : (
          <div className="w-full flex items-center justify-center">
            <div><img className="mr-2" src="/images/icons/khub_heart.svg" alt="bookmark"/></div>
            <div>Like</div>
          </div>
        )
      }
    </button>
  )
}

export { ButtonLike }